import * as types from "./../types";

const initState = {
  cardListDetails: null,
  error: null,
  vkycStatus:null,
};


const CardListReducer = (state = initState, action) => {
  switch (action.type) {
    case types.SAVE_VKYC_STATUS:
      return {
        ...state,
        vkycStatus:action.payload.vkycStatus
      }
    case types.SAVE_BRE_ASSISTED_FLAG:
      return {
        ...state,
        cardListDetails: { ...state.cardListDetails,
          stpBreAssisted:action.payload
        },
        error: action.payload?.error,
      };
	  case types.SAVE_FACE_TO_FACE_FLAG:
        return {
          ...state,
          cardListDetails: { ...state.cardListDetails,
            faceToFace:action.payload
          },
          error: action.payload?.error,
        };
      case types.SAVE_INGESTION2_RESPONSE:
        return {
          ...state,
          cardListDetails: action.payload,
          error: action.payload?.error,
        };
      case types.SAVE_DOWNSELL_CARDS:
        return {
          ...state,
        
        cardListDetails: {
          ...state.cardListDetails,
          eligibleCardTypes:action.payload,
        }
        }
        case types.SAVE_FINAL_CREDIT_LIMIT:
          return {
            ...state,
          
          cardListDetails: {
            ...state.cardListDetails,
            finalCreditLimit:action.payload,
          }
          } 
    default:
      return state;
  }
};

export default CardListReducer;
